import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { URL_SERVICIOS } from '../config/config';
import { ErrorsService } from './errors.service';

@Injectable({
  providedIn: 'root'
})
export class YappService {

  constructor(
    public http: HttpClient,
    public _errors: ErrorsService
  ) { }

 
  async productSearch(body: any) {
    let httpOptions = {
      headers: new HttpHeaders({
        // 'authorization': sessionStorage.getItem('token') || '',
        'Content-Type': 'application/json'
      })
    };

    try {
      // IMPORTANTE: este endpoint debe existir tal cual en tu backend/router
const data = await this.http.post(URL_SERVICIOS + '/yapp/postYappProductSearch', body, httpOptions).toPromise();
      return data;
    } catch (error) {
      // si quieres mantener tu estilo:
      // throw 1;
      // o si quieres registrar:
      this._errors.requestError(error);
      throw error;
    }
  }
}
